import { Component, Input, computed, signal } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MareLoaderModule } from '@mare-common/ngx-mare-loader';
import { MatRadioModule } from '@angular/material/radio';
import { FormGroup, FormsModule, Validators } from '@angular/forms';
import { PromoContent, PromoService } from 'src/app/services/promo.service';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { EventData, EventInteractionService } from '@mare-common/ngx-mare-common';
import { TokenService, WebSolveupLibraryService } from '@mare-common/web-solveup-library';
import { PlatformApiWpService } from 'src/app/services/platform-apiwp.service';
import { Subject, catchError, take, takeUntil } from 'rxjs';
import { NgxAssistanceOpenFormData } from '@mare-common/ngx-assistance-form';
import { NgxDynamicFormDataInputElement } from '@mare-common/ngx-dynamic-form';
import { UserService } from 'src/app/services/user.service';
import { CurrencyFormatterPipe } from 'src/app/shared/pipes/currency-formatter.pipe';
import { environment } from 'src/environments/environment';
import { CompanyService } from 'src/app/services/company.service';
import { CommonConfig } from 'src/app/shared/common-config/common-config';
import { CompanyFinancialStatements, UserCompanyService } from 'src/app/services/userCompany.service';
import { Message } from '@mare-common/ngx-mare-chat';
import { EmergenciesService } from '@mare-common/web-solveup-library';
import { StartChatConfig } from '@mare-common/web-solveup-library/chat-service';
import { MareAuthService } from '@mare-common/ngx-mare-auth';

@Component({
  selector: 'app-component-identity-report',
  templateUrl: './component-identity-report.component.html',
  styleUrls: ['./component-identity-report.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatRadioModule,
    MatIconModule,
    MatButtonModule,
    TranslateModule,
    MareLoaderModule,
    FormsModule],
  providers: [TranslateService],
})
export class ComponentIdentityReportComponent {

  rangeCosti = [
    // { fatturato: 100000, peso: 0.001, costo: 99, fascia1: '50 - 99', fascia2: '99 - 198', fascia3: '198 - 396' },
    // { fatturato: 500000, peso: 0.001, costo: 500, fascia1: '250 - 499', fascia2: '499 - 998', fascia3: '998 - 1996' },
    { fatturato: 1000000, peso: 0.001, costo: 999, fascia1: '500 - 999', fascia2: '999 - 1998', fascia3: '1998 - 3996' },
    { fatturato: 2755234, peso: 0.0004, costo: 1000, fascia1: '500 - 1000', fascia2: '1000 - 2000', fascia3: '2000 - 4000' },
    { fatturato: 5000000, peso: 0.0003, costo: 1477, fascia1: '738 - 1477', fascia2: '1477 - 2954', fascia3: '2954 - 5908' },
    { fatturato: 8500000, peso: 0.0002, costo: 1686, fascia1: '843 - 1686', fascia2: '1686 - 3372', fascia3: '3372 - 6744' },
    { fatturato: 10000000, peso: 0.0002, costo: 2074, fascia1: '1037 - 2074', fascia2: '2074 - 4148', fascia3: '4148 - 8296' },
    { fatturato: 17000000, peso: 0.0002, costo: 2911, fascia1: '1455 - 2911', fascia2: '2911 - 5822', fascia3: '5822 - 11644' },
    { fatturato: 20000000, peso: 0.0002, costo: 3269, fascia1: '1635 - 3269', fascia2: '3269 - 6538', fascia3: '6538 - 13076' },
    { fatturato: 40000000, peso: 0.0001, costo: 5659, fascia1: '2830 - 5659', fascia2: '5659 - 11318', fascia3: '11318 - 22636' },
    { fatturato: 57000000, peso: 0.0001, costo: 7691, fascia1: '3845 - 7691', fascia2: '7691 - 15382', fascia3: '15382 - 30764' },
    { fatturato: 80000000, peso: 0.0001, costo: 10439, fascia1: '5220 - 10439', fascia2: '10439 - 20878', fascia3: '20878 - 41757' },
    { fatturato: 160000000, peso: 0.0001, costo: 19999, fascia1: '10000 - 19999', fascia2: '19999 - 39998', fascia3: '39998 - 79996' },
  ]


  currencyPipe = new CurrencyPipe('it-IT', '€');

  setCompanyRanges() {
    if (!this.company?.localFinancialStatements) {
      return null;
    }
    let filteredData = this.company.localFinancialStatements.filter((data: any) => data.type == 'LocalFinancialsCSIT');
    let latestFinancialStatements = filteredData.sort((a: any, b: any) => new Date(b.yearEndDate).getTime() - new Date(a.yearEndDate).getTime())[0];
    let fatturatoAzienda = latestFinancialStatements.profitAndLoss.totalValueOfProduction;

    let rangeOfCosti = this.findClosestFatturato(this.rangeCosti, fatturatoAzienda);
    // console.log(fatturatoAzienda,this.company.localFinancialStatements,rangeOfCosti)
    if (!rangeOfCosti) {
      rangeOfCosti = this.rangeCosti[0];
    }
    // console.log(this.rangeCosti,rangeOfCosti,fatturatoAzienda)

    const step1 = this.currencyPipe.transform(Math.round((Math.round(rangeOfCosti.costo / 1000) * 1000 * 0.5) - 1), '€', 'symbol', '1.0-0');
    const step2 = this.currencyPipe.transform(Math.round((Math.round(rangeOfCosti.costo / 1000) * 1000 * 1) - 1), '€', 'symbol', '1.0-0');
    const step3 = this.currencyPipe.transform(Math.round((Math.round(rangeOfCosti.costo / 1000) * 1000 * 2) - 1), '€', 'symbol', '1.0-0');
    const step4 = this.currencyPipe.transform(Math.round((Math.round(rangeOfCosti.costo / 1000) * 1000 * 4) - 1), '€', 'symbol', '1.0-0');
    return [
      { label: step1 + ' - ' + step2, value: step1 + ' - ' + step2 },
      { label: step2 + ' - ' + step3, value: step2 + ' - ' + step3 },
      { label: step3 + ' - ' + step4, value: step3 + ' - ' + step4 }
    ]
  }
  // currencyPipe = new CurrencyFormatterPipe();
  ranges$ = signal<Array<{ label: string, value: string }> | []>([]);

  @Input() piva!: string;
  @Input() company!: any;
  @Input() buttononly: boolean = false;
  @Input() buttonlabel: string = 'Vuoi sapere perchè?';
  @Input() buttonfw: boolean = false;
  @Input() buttonclass?: string;
  @Input() getClusterInfo: boolean = false;
  @Input() product?: any;


  myInformationValue: string = '';
  promoData!: PromoContent;
  report_ask_title!: string;
  report_ask_content!: string;
  private unsubscribe$ = new Subject<void>();
  checkingForAfChannel$ = signal<string | null>(null);
  subtitleMessageStaticAssistanceForm!: string;
  companyFinancialStatements!: CompanyFinancialStatements;

  constructor(
    private promoService: PromoService,
    private translateService: TranslateService,
    public dialog: MatDialog,
    private platformApiWpService: PlatformApiWpService,
    private tokenService: TokenService,
    private webSolveupLibraryService: WebSolveupLibraryService,
    private eventInteractionService: EventInteractionService,
    private userService: UserService,
    private companyService: CompanyService,
    private commonConfig: CommonConfig,
    private userCompanyService: UserCompanyService,
    private emergenciesService: EmergenciesService,
    private authService: MareAuthService
  ) {
    translateService.setDefaultLang('it');
    translateService.use('it');

    this.eventInteractionService.getObservable().subscribe((event: EventData) => {
      // console.log(event)
      switch (event.event) {
        case 'closeAssistanceForm':
          this.checkingForAfChannel$.set(null);
          break;
        default:
          break;
      }
    })

  }
  ngOnInit(): void {
    let r: any = this.setCompanyRanges();
    this.ranges$.set(r);
    if (this.getClusterInfo) {


      this.userCompanyService.buildCompanyProfitsLossData().then((res: CompanyFinancialStatements) => {
        if (res) {
          this.companyFinancialStatements = res;
          // console.log(this.companyFinancialStatements);
        }
      });
    }

    if (this.checkIsworkingTime()) {
      this.translateService.get('assistance_form_subtitle_workingtime').subscribe((res) => {
        this.subtitleMessageStaticAssistanceForm = res
      })
    } else {
      this.translateService.get('assistance_form_subtitle_offtime').subscribe((res) => {
        this.subtitleMessageStaticAssistanceForm = res
      })
    }
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  /**
   * Finds the closest element in the given range to the specific fatturato.
   *
   * @param {any[]} rangeCosti - the array of elements to search within
   * @param {any} fatturatoSpecifico - the specific fatturato to find the closest element to
   * @return {any} the closest element to the specific fatturato
   */
  findClosestFatturato(rangeCosti: any[], fatturatoSpecifico: any) {
    let elementoVicino = null;
    let distanzaMinima = Infinity;

    for (const elemento of rangeCosti) {
      const distanzaAssoluta = Math.abs(elemento.fatturato - fatturatoSpecifico);

      if (distanzaAssoluta < distanzaMinima) {
        distanzaMinima = distanzaAssoluta;
        elementoVicino = elemento;
      }

      // Se il fatturato specifico è compreso tra i due valori, interrompi il ciclo
      if (fatturatoSpecifico >= elemento.fatturato && fatturatoSpecifico <= elemento.fatturato) {
        break;
      }
    }
    return elementoVicino;
  }

  /**
   * Finds the closest fatturato inferiore within a given range of costi.
   *
   * @param {any[]} rangeCosti - An array of costi within which to search for the closest fatturato inferiore.
   * @param {any} fatturatoSpecifico - The specific fatturato to find the closest fatturato inferiore to.
   * @return {any} The closest fatturato inferiore within the given range of costi.
   */
  findClosestFatturatoInferiore(rangeCosti: any[], fatturatoSpecifico: any) {
    let elementoVicino = null;
    let distanzaMinima = Infinity;

    for (const elemento of rangeCosti) {
      const distanzaAssoluta = Math.abs(elemento.fatturato - fatturatoSpecifico);

      if (elemento.fatturato <= fatturatoSpecifico && distanzaAssoluta < distanzaMinima) {
        distanzaMinima = distanzaAssoluta;
        elementoVicino = elemento;
      }
    }
    return elementoVicino;
  }

  /**
   * Function to check if it's a working time from 9:00 to 18:00 and Monday to Friday.
   *
   * @param {Date} date - optional: if not provided, current date is got
   * @return {boolean} if true is working time
   */
  checkIsworkingTime(date?: Date) {
    if (!date) {
      date = new Date();
    }
    const day = date.getDay();
    const hour = date.getHours();

    const isWorkingDay = day >= this.commonConfig.getWorkingTime().daystart && day <= this.commonConfig.getWorkingTime().dayend;
    // Controlla se l'ora è all'interno dell'intervallo di lavoro
    const isWorkingTime = hour >= this.commonConfig.getWorkingTime().hourstart && hour <= this.commonConfig.getWorkingTime().hourend;

    if (isWorkingDay && isWorkingTime) {
      return true
    }
    return false


    //   if (hour <= this.commonConfig.getWorkingTime().hourstart && hour >= this.commonConfig.getWorkingTime().hourend) {
    //     return false;
    //   }

    // // Se non è uno dei casi precedenti, l'orario è all'interno dell'orario di lavoro
    // return true;

  }


  getReportSubmit(forceDefaultValue: boolean = false) {
    // console.log(this.myInformationValue);
    this.checkingForAfChannel$.set('In connessione ...');

    if (!this.myInformationValue && forceDefaultValue) {
      this.myInformationValue = this.ranges$() ? this.ranges$()[0].value : '499€ - 999€';
    }

    if (this.authService.isLogged()) {
      this.platformApiWpService.postRequest('/msc/v1/requestReportContact', { reportValue: this.myInformationValue }, false, true).then((sub) => {
        sub.pipe(takeUntil(this.unsubscribe$)).subscribe((ret) => {
          // console.log('requestReportContact', ret);
          // qui controlliamo se siamo in orrio di lavoro e nel caso skippiamo il controllo per operatori in linea
          this._openAssistance();
        })
      })
    } else {
      this._openAssistance();
    }

  }

  private _openAssistance() {
    if (this.checkIsworkingTime()) {
      this.webSolveupLibraryService.getIsAvailableOperators().then(async (isAvailable: boolean) => {
        // console.log('is available', isAvailable)
        if (isAvailable) {

          this.checkingForAfChannel$.set('livechat');

          let tags: string[] = [
            'range: ' + this.myInformationValue,
          ];
          if (this.getClusterInfo && this.companyFinancialStatements?.utilePerso) {
            tags.push('utile perso: ' + Math.round(this.companyFinancialStatements.utilePerso));
          }

          tags.push('piva: ' + this.piva);
          tags.push('tipo: benchmark');

          const user = await this.userService.getUser();
          if (user) {
            if (user.email)
              tags.push('email: ' + user.email);

            if (user.phone)
              tags.push('tel: ' + user.phone);

            if (user.name && user.surname)
              tags.push('utente: ' + user.name + " " + user.surname);
          }

          const company: any = await this.companyService.getCompany();
          if (company) {
            if (company.businessName) {
              tags.push('azienda: ' + company.businessName);
            }

            if (company.id) {
              tags.push('cid: ' + company.id);
              // tags.push(this.commonConfig.getBaseUrl() + '/impersonate-company/?cid=' + company.id);
              tags.push(this.commonConfig.getBaseUrl() + '/company-detail/?cid=' + company.id);
            }
          }
          if (this.product) {
            tags.push('prodotto: ' + this.product.name);
          }

          // this.eventInteractionService.publishData({
          //   event: 'openAssistanceFormPlatform',
          //   data: {
          //     'piva': this.piva,
          //     'prezzo': this.myInformationValue
          //   }
          // })
          const startChatConfig: StartChatConfig = this.commonConfig.getFromConfig('webSolveupStartChatConfig', {
            title: "Conferma",
            subtitle: undefined,
            panelClass: undefined,
            content: '<p>Il consulente vorrebbe contattarti in videochiamata per fornirti maggiori informazioni</p>',
            cancelButtonLabel: 'No',
            cancelButtonColor: 'none',
            acceptButtonLabel: 'OK, avvia una videochiamata',
            acceptButtonColor: 'primary'
          });


          let data: NgxAssistanceOpenFormData = {
            forceOpenForm: false,
            tryUseSolveup: true,
            tryUseQuestionnaire: false,
            askUserToSolveup: false, // flag che se true mostra l'intro dell'assistance form
            tryUseSolveupConfig: {
              tags: tags,
              showFullscreen: true
            },
            webSolveupConfig: {
              handleOnSuccessMessage: "Attendi un operatore: ti risponderà via chat appena possibile",
              unloadMessage: "Sei sicuro di voler chiudere la pagina?",
              closedEmergencyMessageByOperator: "Grazie! Non esitare a ricontattarci.",
              defaultWaitMessage: "Attendere prego...",
              noUserAvailable: "Non ci sono utenti disponibili",
              noOperatorsAvailable: "Non ci sono operatori disponibili",
              genericErrorMessage: "Errore durante la richiesta",
              operatorStartsCallMessage: "Un consulente è entrato in chiamata",
              closedEmergencyMessageByUser: "Grazie! Non esitare a ricontattarci.",
              linkfyEnabled: false,
              enableAudio: true,
              enableVideo: true,
              tryStartChat: true,
              startChatConfig: startChatConfig
            },
            onClickedMessage: (event: { event: any; message: Message; }) => {
              console.log(event);
              let evt: Event = event.event;
              evt.stopImmediatePropagation();
              if (event.message.message.indexOf('http') > -1) {
                let url: any = new URL(event.message.message);
                url = url.pathname + url.search;
                this.eventInteractionService.publishData({ event: 'gotoLink', data: { url: url } });
                this.eventInteractionService.publishData({ event: 'setVideocallFullscreen', data: false });
              }
            }
          };
          this.eventInteractionService.publishData({ event: 'openAssistanceForm', data: data });
        } else {
          this.checkingForAfChannel$.set('offline');
          this.manageNotifyOperatorsForRequest();
          this.startForm(true);
        }
      }).catch((err) => {
        console.log(err);
        this.checkingForAfChannel$.set('offline');
        this.manageNotifyOperatorsForRequest();
        this.startForm(true);
      });
    } else {
      this.checkingForAfChannel$.set('offline');
      this.startForm(true);
    }
  }

  async manageNotifyOperatorsForRequest() {

    if (this.commonConfig.getFromConfig('disableNotifyLostRequestestInWorkingTime') || !this.authService.isLogged()) {
      return;
    }

    this.userCompanyService.userCompany$.pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
      if (!res)
        return;
      const user = res.user;
      const company = res.company;
      const request = {
        user_name: user?.name + " " + user?.surname,
        company: company?.business_name ?? '--',
        email: user?.email,
        product: 'Benchmark',
        product_value: this.myInformationValue,
        timestamp: new Date().toISOString(),
      }
      this.platformApiWpService.postRequest('/msc/v1/notifyRequestOffline', request, false, true).then((sub) => {
        sub.pipe(take(1)).subscribe((ret) => {
          // qui riceviamo la risposta di wordpress alla funzione di wp_mail (success/fail);
          console.info(ret);
        })

      })

    })
  }

  async startForm(isOutWorkingTime?: boolean) {
    let user: any = null;
    let formGroup = new FormGroup({});
    let dataInput: any = {};
    if(this.authService.isLogged()) {
      user = await this.userService.getUser();
      
      dataInput = this.getDataInputs({
        name: user?.name,
        email: user?.email,
        phone: user?.phone,
        reportValue: this.myInformationValue,
        piva: this.piva
      })
      let tags: string[] = ['tipo: benchmark', 'piva: ' + this.piva, 'range: ' + this.myInformationValue];

    if (user) {
      if (user.email)
        tags.push('email: ' + user.email)

      if (user.phone)
        tags.push('tel: ' + user.phone)

      if (user.name && user.surname)
        tags.push('utente: ' + user.name + " " + user.surname)
    }
    this.userCompanyService.userCompany$.pipe(takeUntil(this.unsubscribe$)).subscribe((res: any) => {
      if (res?.company?.profitLost) {
        tags.push('Utile perso: ' + res.company.profitLost)
      }
    })
    } else {
      dataInput = this.getDataInputs();
    }
    

    // let data_: NgxAssistanceOpenFormData = {
    //   forceOpenForm: true,
    //   tryUseQuestionnaire: false,
    //   tryUseSolveup: false,
    //   askUserToSolveup: false,
    //   dynamicFormConfig: {
    //     isDynamicFormEnabled: true,
    //     preventSendForm: true,
    //     eventType: 'dynamicFormClicked',
    //     dynamicFormConfig: {
    //       // topHeader: 'Hai bisogno di aiuto?',
    //       // header: 'Usa il form di seguito per inviarci i tuoi feedback, per segnalare eventuali anomalie o anche per richiedere assistenza.',
    //       formGroup: formGroup,
    //       dataInput: dataInput,
    //       elements: dataInput,
    //       displayedColumns: [],
    //       formWrapperClass: 'af-form-assistance-form pt--32',
    //       formClass: 'form-class-1 form-class-2',
    //       template: 'GRID'
    //     }
    //   },
    //   webSolveupConfig: {
    //     handleOnSuccessMessage: "Attendi un operatore: ti risponderà via chat appena possibile",
    //     unloadMessage: "Sei sicuro di voler chiudere la pagina?",
    //     closedEmergencyMessageByOperator: "L'operatore ha terminato la sessione",
    //     defaultWaitMessage: "Attendere prego...",
    //     noUserAvailable: "Non ci sono utenti disponibili pp",
    //     noOperatorsAvailable: "Non ci sono operatori disponibili",
    //     genericErrorMessage: "Errore durante la richiesta",
    //     operatorStartsCallMessage: "Un operatore è entrato in chiamata",
    //     closedEmergencyMessageByUser: "Hai terminato la sessione",
    //     linkfyEnabled: false,
    //     enableAudio: true,
    //     enableVideo: true,
    //     tryStartChat: false
    //   }
    // }

    

    let data: NgxAssistanceOpenFormData = {
      forceOpenForm: true,
      tryUseSolveup: false,
      tryUseQuestionnaire: false,
      localQuestionnaireConfig: undefined,
      staticForm: {
        title: 'Richiedi informazioni',
        subtitle: this.subtitleMessageStaticAssistanceForm,
      },
      dynamicFormConfig: {
        isDynamicFormEnabled: true,
        preventSendForm: true,
        dynamicFormConfig: {
          // topHeader: 'Richiedi informazioni',
          // header: 'Un operatore non è attualmente disponibile. Compila in form qui sotto e sarai ricontattato il prima possibile.',
          formGroup: formGroup,
          dataInput: dataInput,
          elements: dataInput,
          displayedColumns: [],
          formWrapperClass: 'af-form-assistance-form pt--32',
          formClass: 'form-class-1 form-class-2',
          template: 'GRID',
          buttons: [
            {
              color: "primary",
              hasIcon: false,
              label: 'Invia',
              closeDialog: false,
              action: (par: any) => { this.inviaButtonClicked(formGroup) },
            },
            {
              color: "accent",
              hasIcon: false,
              label: 'Annulla',
              closeDialog: false,
              action: (par: any) => { this.annullaButtonClicked(formGroup) },
            }
          ]
        }
      },
      askUserToSolveup: false,
      tryUseSolveupConfig: undefined,
      webSolveupConfig: {
        handleOnSuccessMessage: "Attendi un operatore: ti risponderà via chat appena possibile",
        unloadMessage: "Sei sicuro di voler chiudere la pagina?",
        closedEmergencyMessageByOperator: "L'operatore ha terminato la sessione",
        defaultWaitMessage: "Attendere prego...",
        noUserAvailable: "Non ci sono utenti disponibili",
        noOperatorsAvailable: "Non ci sono operatori disponibili",
        genericErrorMessage: "Errore durante la richiesta",
        operatorStartsCallMessage: "Un operatore è entrato in chiamata",
        closedEmergencyMessageByUser: "Hai terminato la sessione",
        linkfyEnabled: false,
        enableAudio: true,
        enableVideo: true,
        tryStartChat: false
      }
    }
    // TODO deve aprire il form di contatto
    this.eventInteractionService.publishData({
      event: 'openAssistanceForm',
      data: data
    })
  }

  inviaButtonClicked(par: any) {
    // console.log(par);
    this.submitForm(par.value).then((res: any) => {
      // console.log(res);
      this.eventInteractionService.publishData({
        event: 'showRecap',
        data: true
      })
    })
  }

  public submitForm(body: any): Promise<any> {
    return new Promise((resolve, reject) => {

      const wpbody = {
        _wpcf7: environment.wpReportFormId,
        "assistance-name": body.name,
        "assistance-email": body.email,
        "assistance-vatNumber": body.piva,
        "assistance-phone": body.phone,
        "assistance-reportValue": body.reportValue,
        "assistance-message": body.message
      }
      this.platformApiWpService.postRequest('msc/v1/submitForm', wpbody).then((sub: any) => {
        sub
          .pipe(
            catchError((err: any) => {
              reject(err);
              console.log(err);
              return err;
            })
          )
          .subscribe((data: any) => {
            // console.log(data);
            resolve(data);
          });
      });
    });
  }

  annullaButtonClicked(par: any) {
    // console.log(par);
    this.eventInteractionService.publishData({
      event: 'closeAssistanceForm'
    })
    // this.checkingForAfChannel$.set(null);
  }

  getDataInputs(data?: {
    name?: string,
    email?: string,
    phone?: string,
    reportValue?: string,
    piva?: string
  }): Array<NgxDynamicFormDataInputElement> {
    return [
      {
        type: 'TEXT',
        formControlName: 'name',
        id: 'name',
        placeholder: 'Nome',
        label: 'Nome',
        required: true,
        value: data?.name
      },
      {
        type: 'TEXT',
        formControlName: 'email',
        id: 'email',
        placeholder: 'Email',
        label: 'Email',
        required: true,
        value: data?.email,
        validators: [
          // eslint-disable-next-line no-useless-escape
          Validators.required, Validators.pattern(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
        ]
      },
      // {
      //   type: 'SELECT',
      //   formControlName: 'tipo',
      //   id: 'tipo',
      //   placeholder: 'Tipo',
      //   label: 'Tipologia di supporto',
      //   required: true,
      //   options: [{
      //     value: '1',
      //     name: 'Richiesta di assistenza'
      //   },
      //   {
      //     value: '2',
      //     name: 'Segnalazione di anomalie'
      //   },
      //   {
      //     value: '3',
      //     name: 'Feedback'
      //   },
      //   {
      //     value: '4',
      //     name: 'Altro'
      //   }

      //   ],
      //   validators: [
      //     Validators.required
      //   ]
      // },
      {
        type: 'TEXT',
        formControlName: 'phone',
        id: 'phone',
        placeholder: 'Telefono',
        label: 'Telefono',
        value: data?.phone,
        required: true,
      },
      {
        type: 'TEXTAREA',
        formControlName: 'message',
        id: 'message',
        placeholder: 'Messaggio',
        label: 'Cosa vuoi chiederci',
        value: 'Sono interessato ad avere maggiori informazioni sul Benchmark!',
        required: true,
      },
      // {
      //   type: 'CHECK',
      //   formControlName: 'acceptance',
      //   id: 'acceptance',
      //   required: true,
      //   // placeholder: 'Accetto che i miei dati inviati vengano raccolti e archiviati!',
      //   label: 'Accetto che i miei dati inviati vengano raccolti e archiviati!',
      // },
      {
        type: 'TEXT',
        formControlName: 'reportValue',
        id: 'reportValue',
        placeholder: 'Valore del Benchmark',
        label: 'Valore del Benchmark',
        required: true,
        isVisible: false,
        visibleIf: {
          formControlName: 'email',
          checkFunction: (data: any) => { return false }
        },
        value: data?.reportValue
      },
      {
        type: 'TEXT',
        formControlName: 'piva',
        id: 'piva',
        placeholder: 'piva',
        label: 'piva',
        required: true,
        isVisible: false,
        visibleIf: {
          formControlName: 'email',
          checkFunction: (data: any) => { return false }
        },
        value: data?.piva
      },
      // {
      //   type: 'EXTERNAL',
      //   formControlName: 'recaptcha',
      //   id: 'recaptcha',
      //   required: true,
      //   externalComponent: {
      //     component: ReCaptcha2Component,
      //     inputs: [{
      //       key: 'siteKey',
      //       value: '6LduNgIgAAAAAHof_ne8DYBSuBeQyeFOoAqZsO3L',
      //     }],
      //     outputs: [
      //       {
      //         key: 'reset',
      //         value: (event: any) => {
      //           console.info(event)
      //         },
      //       },
      //       {
      //         key: 'expire',
      //         value: (event: any) => {
      //           console.info(event)
      //         },
      //       },
      //       {
      //         key: 'load',
      //         value: (event: any) => {
      //           console.info(event)
      //         },
      //       },
      //       {
      //         key: 'success',
      //         value: (event: any) => {
      //           console.info(event)
      //         },
      //       }]
      //   }
      // }
    ]
  };

}
